import axios from 'axios'
import fileDownload from 'js-file-download'
import Debug from 'debug'

import { getAuthToken, getIpbxApiUrl } from '../utils/functions'

const debug = Debug('api')

export const api = axios.create({
  baseURL: getIpbxApiUrl(),
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Inject token to all requests
api.interceptors.request.use(
  config => {
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        ...config.headers
      }
    }
  },
  err => Promise.reject(err)
)

export async function getRecordStream(filename, pbxId) {
  if (!filename || !pbxId) throw new Error('No filename or pbxId provided')

  const response = await api.get(`/recordings/${encodeURIComponent(filename)}/ipbx/${pbxId}`, {
    responseType: 'blob'
  })
  const blob = new window.Blob([response.data], { type: 'application/octet-stream' })
  return window.URL.createObjectURL(blob)
}

export async function downloadRecordingsZip(callId, filename = 'recordings') {
  if (!callId) throw new Error('No callId provided')

  const response = await api.get(`/recordings/download?callId=${callId}`, {
    responseType: 'blob'
  })
  return fileDownload(response.data, `${filename}.zip`)
}

export async function getAuthInfo() {
  const { data } = await api.get('auth/roles')
  debug('fetching /auth/roles', data)

  return {
    anvilId: data.anvilId || '',
    email: data.email || '',
    roles: data.pbxRoles || [],
    id: data.pbx?.id || '',
    version: data.pbx?.version || '',
    hostname: data.pbx?.hostname,
    modules: data.pbx?.modules || {}
  }
}

export async function pbxLogin() {
  debug('logging into PBX...')
  // Invalidate php session cookie for PBX-OLD before new login
  document.cookie = 'PHPSESSID=deleted;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  return await api.request({
    method: 'post',
    baseURL: '/php',
    url: '/admin/auth.php'
  })
}

export async function pbxLogout() {
  debug('logging out PBX...')
  return api.request({
    method: 'get',
    baseURL: '/php',
    url: '/admin/index.php?akce=logout&redirect=false',
    withCredentials: true
  })
}
